import Card from './src/Card';

export default Card;
